export interface CreateNewSessionAndGetChatBotRootRequest {
  chatBotId: number
  chatBotToken: string
  lang: string
  channel: ChannelEnum
}

export enum ChannelEnum {
  webPage = 1,
  whatsApp = 2
}
